var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { css } from '@emotion/react';
import { darkThemeStyle, theme } from '../theme';
import { loaderEndMask, loaderStartMask, stroke } from './keyframes';
var animationSettings = '2s infinite alternate';
var wrapperStaticStyle = css({
    animation: "".concat(loaderStartMask, " cubic-bezier(0.65, 0, 0.55, 1) ").concat(animationSettings),
    willChange: 'clip-path',
});
export function wrapperStyle(_a) {
    var height = _a.height, width = _a.width;
    return [
        wrapperStaticStyle,
        width != null && css({ width: width }),
        height != null && css({ height: height }),
    ];
}
export var containerStaticStyle = css({
    animation: "".concat(loaderEndMask, " cubic-bezier(0, 0, 0.85, 1) ").concat(animationSettings),
    willChange: 'clip-path',
});
export var svgWrapperStaticStyle = css({
    clipPath: 'polygon(-0.1% -10%, 169% 65%, -0.1% 139%)',
});
var loaderSvgStaticStyle = css({
    display: 'block',
    overflow: 'visible',
    stroke: theme.text.main,
});
export function loaderSvgStyle(_a) {
    var inverted = _a.inverted;
    return __spreadArray(__spreadArray([], __read((inverted ? [darkThemeStyle] : [])), false), [loaderSvgStaticStyle], false);
}
export var loaderPathStaticStyle = css({
    animation: "".concat(stroke, " cubic-bezier(0.65, 0, 0.55, 1) ").concat(animationSettings),
    strokeDasharray: 9800,
    strokeDashoffset: 9800,
    willChange: 'stroke-dashoffset',
});
